import { BDDialog } from '@brightdrop/bd-ui';
import { useTranslation } from 'react-i18next';

import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import InactiveUserCountdownModal from '~/hooks/useInactivityTracker/InactiveUserCountdownModal';
import useInactivityTracker from '~/hooks/useInactivityTracker/useInactivityTracker';

const InactiveUserCountdownModalWrapper = (): JSX.Element => {
  const { isUserInactive, resetAllTimers, idleTimeout } =
    useInactivityTracker();
  // Subscribe to i18n so the imperative `translateText(...)` title re-renders on locale change.
  useTranslation(['common']);

  //extends session in all tabs and dismisses the modal in other tabs
  const handleCloseInactiveUser = (isSuccess: boolean) => {
    if (isSuccess) {
      resetAllTimers();
    }
  };

  return (
    <BDDialog
      openModal={isUserInactive}
      title={translateText('common:inactivity:modal:header')}
      onCloseModal={handleCloseInactiveUser}
      entity={undefined}
      component={(props) => (
        <InactiveUserCountdownModal {...props} idleTimeout={idleTimeout} />
      )}
      disableClose={true}
    />
  );
};

export default InactiveUserCountdownModalWrapper;
